import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Critical resource hints and preloads
const setupCriticalResources = () => {
  // DNS prefetch for CDN (earliest possible)
  const dnsPrefetch = document.createElement('link');
  dnsPrefetch.rel = 'dns-prefetch';
  dnsPrefetch.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(dnsPrefetch);
  // Preconnect to Google Fonts
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect1);
  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);
  // Preload hero image (LCP optimization)
  const heroPreload = document.createElement('link');
  heroPreload.rel = 'preload';
  heroPreload.as = 'image';
  heroPreload.href = 'https://cdn.magicpatterns.com/uploads/kpqeeJXPW4oe2uvVr6ePv9/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).png';
  heroPreload.fetchPriority = 'high';
  document.head.appendChild(heroPreload);
  // Load Google Fonts NON-BLOCKING (media="print" trick)
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&display=swap';
  fontLink.media = 'print';
  fontLink.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  document.head.appendChild(fontLink);
};
// Execute critical resource setup
setupCriticalResources();
render(<App data-id="element-165" />, document.getElementById('root'));